<ion-content class="ion-padding">
  <div class="tooltip-text">{{ text }}</div>
  <div *ngIf="picture" class="tooltip-picture">
    <img [src]="picture" [alt]="text" />
  </div>
  <div class="button-container" *ngIf="button">
    <ion-button size="small" color="tetratech" (click)="handleClick()">{{button.label}}</ion-button>
  </div>
</ion-content>